import React from 'react'
import Translations from '@helpers/translations'
import { SHIPPING_FEES } from '@consts/index'
import styles from './styles.module.scss'
import { checkStoreIs } from '@helpers/env'

function getShippingFees(): string {
  return checkStoreIs('us')
    ? 'No hidden taxes or charges - US tariffs are covered by SPOKE'
    : `${Translations.localise('common.sweetenersList.option-1')} ${
        SHIPPING_FEES.threshold[process.env.SHOP_LOCALE].cost
      }`
}

function SweetenersList() {
  return (
    <p className={styles.sweetenersList}>
      {getShippingFees()} |{' '}
      {Translations.localise('common.sweetenersList.option-3')}
    </p>
  )
}

export default SweetenersList
